import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const ProjectTypes: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/projectTypes')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/workflowsetup/projectType/add', { state: { title: 'New project type', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/projectTypes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Project types'
                                content={
                                    <DataTable
                                        name='dtProjectTypes'
                                        tableData={data}
                                        navigateTitle='Project type'
                                        navigateUrl='/plm/workflowsetup/projecttype/'
                                        colInfos={[
                                            { key: true, dataProp: 'id', visible: false },
                                            { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                                            {
                                                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                                                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
                                            }
                                        ]}

                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default ProjectTypes;